import __request__ from "routing/request";
export function getAction(sidecarId, requestOptions) {
  return __request__("GET", `/sidecar/action/${sidecarId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setAction(sidecarId, JSONbody, requestOptions) {
  return __request__("PUT", `/sidecar/action/${sidecarId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
